<form class="ui modal">
    <div class="ui header">
      Go to page
    </div>
    <div class="content ui form">
      <div class="field">
        <label for="current-page">Please select a page from {{min}} to {{max}}:</label>
        <input [(ngModel)]="current" id="current-page" name="current-page" type="number" [max]="max" [min]="min">
      </div>
      <div class="field">
        <div *ngIf="invalidPageError" class="ui tiny negative message">
            <i (click)="invalidPageError = false" class="close icon"></i>
            <div class="header">
            Page not valid
            </div>
            <p>
            Select a page from {{min}} to {{max}}
            </p>
        </div>
    </div>
    </div>
    <div class="actions">
      <button type="button" class="ui basic cancel button">Cancel</button>
      <button (click)="save($event)" type="submit" class="ui positive button">Go to</button>
    </div>
  </form>
  